"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var firebase_1 = require("./firebase");
var Base = /** @class */ (function () {
    function Base(id) {
        var _this = this;
        this.ref = function (path) {
            return firebase_1.db.ref(path);
        };
        this.getByPath = function (path) {
            return _this.ref(path);
        };
        this.create = function (path, object) {
            if (object.audit) {
                object.audit.createdAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
                object.audit.updatedAt = firebase_1.dbConstants.ServerValue.TIMESTAMP;
            }
            var newRef = _this.ref(path).push();
            newRef.set(object);
            return newRef;
        };
        this.update = function (path, object) {
            return _this.ref(path).update(object);
        };
        this.set = function (path, object) {
            return _this.ref(path).set(object);
        };
        this.deleteByPath = function (path) {
            return _this.ref(path).remove();
        };
        this.getId = function () {
            return _this.id;
        };
        this.getApiResponse = function (orgId, uid, requestId) {
            return _this.getByPath("/apis/" + orgId + "/" + uid + "/responses/" + requestId);
        };
        this.id = id;
    }
    Base.prototype.updateName = function (resourceId, config) {
        throw new Error("method not implemented");
    };
    ;
    Base.prototype.getAuthRoles = function (userId, resourceId) {
        throw new Error("method not implemented");
    };
    ;
    Base.prototype.requestListMembers = function (orgId, authUserId, resourceId) {
        throw new Error("method not implemented");
    };
    ;
    Base.prototype.addUserToResource = function (orgId, authUserId, resourceId, userId) {
        throw new Error("method not implemented");
    };
    ;
    Base.prototype.deleteUserToResource = function (orgId, authUserId, resourceId, userId) {
        throw new Error("method not implemented");
    };
    ;
    Base.prototype.changePermissionToResource = function (orgId, authUserId, resourceId, userId, newPermission) {
        throw new Error("method not implemented");
    };
    ;
    Base.prototype.deleteResource = function (authUserId, resourceId) {
        throw new Error("method not implemented");
    };
    ;
    return Base;
}());
exports.default = Base;
//# sourceMappingURL=Base.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/data/Base.js
// module id = 53
// module chunks = 8